export default __webpack_public_path__ + "static/media/kitchen5-afterE-2048w.28015c0d.avif";